export default __webpack_public_path__ + "static/svami-6b8a7da68bb19d2086f5e80c6b5466cf.png";